import React, { useState } from 'react';

 /* eslint-disable react/prop-types */
function CarroucelImg(props) {
    let [countImgShowing, setCountImgShowing] = useState(0);
    const [imageSrc, setImageSrc] = useState(props.carroucelImg[countImgShowing].url);
    const [arrowSrcLeft, setArrowSrcLeft] = useState("./img/leftArrow.png");
    const [arrowSrcRight, setArrowSrcRight] = useState("./img/rigthArrow.png");
    

    const imgRotation = (event) => {
        let imgToShow = countImgShowing;
        if (event && event.target && event.target.attributes && event.target.attributes["orientation"].value === "left") {
            if ((imgToShow -1) >= 0) {
                imgToShow = imgToShow - 1;
            } else if (imgToShow === 0) {
                imgToShow = props.carroucelImg.length -1;
            }
        } else if (event && event.target && event.target.attributes && event.target.attributes["orientation"].value === "right") {
            if ((imgToShow +1) <= (props.carroucelImg.length -1) ) {
                imgToShow = imgToShow + 1;
            } else if(imgToShow === (props.carroucelImg.length -1)) {
                imgToShow = 0;
            }
        }
        setCountImgShowing(imgToShow);
        setImageSrc(props.carroucelImg[imgToShow].url);
    }

    if (props && props.arrows === "white" && arrowSrcLeft !== './img/whiteLeftArrow.png') {
        setArrowSrcLeft('./img/whiteLeftArrow.png');
        setArrowSrcRight('./img/whiteRigthArrow.png');
    }

    let arrowStyles = {
        display: "flex",
        justifyContent: "flex-end",
        paddingRight: "30px"
    }
    let imageMainCointainer = {
        width: "100%", 
        textAlign: "center"
    }
    return (
        <div id="imageContainer" style={imageMainCointainer}>
            <div>
                <img src={imageSrc} width="250px" style={{maxWidth: "300px" }} alt='' />
            </div>
            { props.carroucelImg.length > 1 && 
                <div style={arrowStyles}>
                    <div style={{ paddingRight: "10px" }}>
                        <img src={arrowSrcLeft} width="25px" height="25px" orientation="left" onClick={imgRotation} alt=''/>
                    </div>
                    <div >
                        <img src={arrowSrcRight} width="25px" height="25px" orientation="right" onClick={imgRotation} alt=''/>
                    </div>
                </div>
            }
        </div>
    )
}

export default CarroucelImg;